<template>
    <transition name="bounce">
        <button
            v-show="isVisible"
            class="back-to-top"
            @click="scrollToTop"
        >
            <van-icon
                name="arrow-up"
                size="20px"
            />
        </button>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            isVisible: false,
        };
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll() {
            this.isVisible = window.scrollY > 300;
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
    },
};
</script>

<style scoped>
.back-to-top {
    position: fixed;
    bottom: 90px;
    right: 10px;
    z-index: 999;
    /* background: linear-gradient(145deg, #007bff, #0056b3); */
    background: #EFDB01;
    color: black;
    border: none;
    padding: 12px 18px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.2),
        -4px -4px 10px rgba(255, 255, 255, 0.1);
    transition: all 0.2s ease-in-out;
}

.back-to-top:active {
    box-shadow: inset 4px 4px 10px rgba(0, 0, 0, 0.3),
        inset -4px -4px 10px rgba(255, 255, 255, 0.1);
    transform: translateY(3px);
}

.back-to-top:hover {
    background: #C7B700;
}

/* Bounce Animation */
@keyframes bounceIn {
    0% {
        transform: scale(0.5);
        opacity: 0;
    }

    50% {
        transform: scale(1.15);
        opacity: 1;
    }

    100% {
        transform: scale(1);
    }
}

/* Vue Transition Classes */
.bounce-enter-active {
    animation: bounceIn 0.6s ease-out;
}

.bounce-leave-active {
    animation: bounceIn 0.4s ease-in reverse;
}
</style>
